import { memo, useCallback } from 'react';
import SpeakerLabelNumberInput from './SpeakerLabelNumberInput';

interface Props {
  value: string;
  onChange: (value: string) => void;
}

const SpeakerLabelLetterSpacingInput = memo(({ value, onChange }: Props) => {
  const handleFormatOutput = useCallback((value: number) => {
    return `${value / 100}em`;
  }, []);

  const handleParseInput = useCallback((value: string) => {
    if (!value || value === 'normal') {
      return 0;
    }
    const emValue = parseFloat(value.replace('em', ''));
    return isNaN(emValue) ? 0 : emValue;
  }, []);

  return (
    <SpeakerLabelNumberInput
      value={value}
      onChange={onChange}
      min={-2}
      max={2}
      step={0.1}
      unit="x"
      defaultValue="0"
      testId="letter-spacing-input"
      ariaLabel="Letter spacing"
      incrementLabel="Increase letter spacing"
      decrementLabel="Decrease letter spacing"
      formatOutput={handleFormatOutput}
      parseInput={handleParseInput}
    />
  );
});

export default SpeakerLabelLetterSpacingInput;
